var map = {
	"./accessibility-man-icon.svg": 7124,
	"./black-and-white.svg": 1776,
	"./call.svg": 6111,
	"./camera.svg": 8854,
	"./circle-notch.svg": 4942,
	"./decrease-font-size.svg": 8251,
	"./facebook-f.svg": 7214,
	"./global.svg": 2566,
	"./hide-images.svg": 6090,
	"./highlight-links.svg": 6793,
	"./iconmonstr-youtube-1.svg": 3913,
	"./increase-font-size.svg": 3655,
	"./invert-colours.svg": 479,
	"./linkedin-in.svg": 2047,
	"./mail.svg": 9814,
	"./map-alt.svg": 4793,
	"./negative-contrast.svg": 4813,
	"./paperclip.svg": 9081,
	"./reading-mask.svg": 3986,
	"./reset-font.svg": 1718,
	"./spinner.svg": 4094,
	"./verified.svg": 5523,
	"./x-mark.svg": 5465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;